<!-- 系统设置 权限管理 账号管理 运营配置 -->
<template>
  <ykc-drawer :show.sync="showDrawer" destroy-on-close title="运营配置" @open="handleOpen">
    <template #footer>
      <div class="drawer-button-wrap">
        <ykc-button type="plain" @click="handleCancel">取消</ykc-button>
        <ykc-button @click="handleSave">保存</ykc-button>
      </div>
    </template>
    <div class="drawer-main-body">
      <ykc-form ref="operationForm" :model="model" :rules="rules" class="el-form-wrap">
        <ykc-form-item label="账号">
          {{ currentAccount?.accountNo }}
        </ykc-form-item>
        <ykc-form-item label="姓名">
          {{ currentAccount?.accountName }}
        </ykc-form-item>

        <!-- 负责城市 -->
        <div class="city-section">
          <div class="city-section-header">
            <span class="city-section-title">负责城市</span>
            <ykc-button type="plain" size="small" @click="addResponsibleCity">
              + 添加负责城市
            </ykc-button>
          </div>
          <div
            v-for="(item, index) in model.responsibleCities"
            :key="'r-' + index"
            class="city-row">
            <el-cascader
              :options="addressData"
              placeholder="请选择省/市/区"
              v-model="item.ids"
              :props="{ value: 'id', label: 'name', children: 'subNodes', checkStrictly: true }"
              clearable
              filterable
              style="flex: 1"
              @change="val => onResponsibleCityChange(index, val)"></el-cascader>
            <span v-if="item.ids && item.ids.length > 0 && item.ids.length < 2" class="error-tip">
              至少需选择到市级
            </span>
            <ykc-button
              type="text"
              @click="removeResponsibleCity(index)"
              style="margin-left: 8px; color: #f56c6c">
              删除
            </ykc-button>
          </div>
          <div v-if="model.responsibleCities.length === 0" class="city-empty">暂未设置负责城市</div>
        </div>

        <!-- 常驻城市 -->
        <div class="city-section">
          <div class="city-section-header">
            <span class="city-section-title">常驻城市</span>
            <ykc-button type="plain" size="small" @click="addPermanentCity">
              + 添加常驻城市
            </ykc-button>
          </div>
          <div v-for="(item, index) in model.permanentCities" :key="'p-' + index" class="city-row">
            <el-cascader
              :options="addressData"
              placeholder="请选择省/市/区"
              v-model="item.ids"
              :props="{ value: 'id', label: 'name', children: 'subNodes', checkStrictly: true }"
              clearable
              filterable
              style="flex: 1"
              @change="val => onPermanentCityChange(index, val)"></el-cascader>
            <span v-if="item.ids && item.ids.length > 0 && item.ids.length < 2" class="error-tip">
              至少需选择到市级
            </span>
            <ykc-button
              type="text"
              @click="removePermanentCity(index)"
              style="margin-left: 8px; color: #f56c6c">
              删除
            </ykc-button>
          </div>
          <div v-if="model.permanentCities.length === 0" class="city-empty">暂未设置常驻城市</div>
        </div>
      </ykc-form>
    </div>
  </ykc-drawer>
</template>

<script>
  import { accountManage, treeUtils } from '@/service/apis';

  export default {
    name: 'OperationSettingDrawer',
    props: {
      showCwd: {
        type: Boolean,
        default: false,
      },
      currentAccount: {
        type: Object,
        default: null,
      },
    },
    data() {
      return {
        addressData: [],
        model: {
          permanentCities: [],
          responsibleCities: [],
        },
        rules: {},
      };
    },
    computed: {
      showDrawer: {
        get() {
          return this.showCwd;
        },
        set(val) {
          this.$emit('update:showCwd', val);
        },
      },
    },
    created() {
      this.requestGetDistrict();
    },
    methods: {
      /** 获取区域数据 */
      requestGetDistrict() {
        treeUtils
          .getDistrict({})
          .then(res => {
            this.addressData = res.districts;
          })
          .catch(err => {
            console.log(err);
          });
      },
      /** 抽屉打开时加载数据 */
      handleOpen() {
        this.model = {
          permanentCities: [],
          responsibleCities: [],
        };
        if (this.currentAccount?.id) {
          this.loadData(this.currentAccount.id);
        }
      },
      /** 加载运营配置数据 */
      loadData(accountId) {
        accountManage.queryOperationSetting(accountId).then(res => {
          if (res) {
            // 回显负责城市
            if (res.responsibleCities && res.responsibleCities.length > 0) {
              /* eslint-disable prefer-destructuring */
              this.model.responsibleCities = res.responsibleCities.map(item => ({
                ids: [item.provinceId, item.cityId, item.districtId].filter(Boolean),
                provinceId: item.provinceId,
                cityId: item.cityId,
                districtId: item.districtId,
              }));
              /* eslint-enable prefer-destructuring */
            }
            // 回显常驻城市
            if (res.permanentCities && res.permanentCities.length > 0) {
              /* eslint-disable prefer-destructuring */
              this.model.permanentCities = res.permanentCities.map(item => ({
                ids: [item.provinceId, item.cityId, item.districtId].filter(Boolean),
                provinceId: item.provinceId,
                cityId: item.cityId,
                districtId: item.districtId,
              }));
              /* eslint-enable prefer-destructuring */
            }
          }
        });
      },
      /** 负责城市选择变化 */
      onResponsibleCityChange(index, val) {
        const item = this.model.responsibleCities[index];
        if (val && val.length > 0) {
          item.provinceId = val[0];
          item.cityId = val.length >= 2 ? val[1] : null;
          item.districtId = val.length >= 3 ? val[2] : null;
        }
      },
      /** 常驻城市选择变化 */
      onPermanentCityChange(index, val) {
        const item = this.model.permanentCities[index];
        if (val && val.length > 0) {
          item.provinceId = val[0];
          item.cityId = val.length >= 2 ? val[1] : null;
          item.districtId = val.length >= 3 ? val[2] : null;
        }
      },
      /** 添加负责城市 */
      addResponsibleCity() {
        /* eslint-disable prefer-destructuring */
        this.model.responsibleCities.push({
          ids: [],
          provinceId: null,
          cityId: null,
          districtId: null,
        });
        /* eslint-enable prefer-destructuring */
      },
      /** 删除负责城市 */
      removeResponsibleCity(index) {
        /* eslint-disable prefer-destructuring */
        this.model.responsibleCities.splice(index, 1);
        /* eslint-enable prefer-destructuring */
      },
      /** 添加常驻城市 */
      addPermanentCity() {
        /* eslint-disable prefer-destructuring */
        this.model.permanentCities.push({
          ids: [],
          provinceId: null,
          cityId: null,
          districtId: null,
        });
        /* eslint-enable prefer-destructuring */
      },
      /** 删除常驻城市 */
      removePermanentCity(index) {
        /* eslint-disable prefer-destructuring */
        this.model.permanentCities.splice(index, 1);
        /* eslint-enable prefer-destructuring */
      },
      /** 保存 */
      handleSave() {
        const accountId = this.currentAccount?.id;
        if (!accountId) {
          this.$message.warning('账号信息缺失');
          return;
        }

        // 验证负责城市：至少需要选择到市级
        const invalidResponsible = this.model.responsibleCities.filter(
          item => item.ids && item.ids.length > 0 && item.ids.length < 2
        );
        if (invalidResponsible.length > 0) {
          this.$message.warning('负责城市至少需选择到市级，请检查并完善');
          return;
        }

        // 验证常驻城市：至少需要选择到市级
        const invalidPermanent = this.model.permanentCities.filter(
          item => item.ids && item.ids.length > 0 && item.ids.length < 2
        );
        if (invalidPermanent.length > 0) {
          this.$message.warning('常驻城市至少需选择到市级，请检查并完善');
          return;
        }

        // 构造请求参数
        /* eslint-disable prefer-destructuring */
        const responsibleCities = this.model.responsibleCities
          .filter(item => item.ids && item.ids.length >= 2) // 必须至少有省和市
          .map(item => ({
            provinceId: item.ids[0],
            cityId: item.ids[1],
            districtId: item.ids.length >= 3 ? item.ids[2] : null,
          }));

        const permanentCities = this.model.permanentCities
          .filter(item => item.ids && item.ids.length >= 2) // 必须至少有省和市
          .map(item => ({
            provinceId: item.ids[0],
            cityId: item.ids[1],
            districtId: item.ids.length >= 3 ? item.ids[2] : null,
          }));
        /* eslint-enable prefer-destructuring */

        accountManage
          .saveOperationSetting({
            accountId,
            responsibleCities,
            permanentCities,
          })
          .then(() => {
            this.$message.success('保存成功');
            this.showDrawer = false;
            this.$emit('refresh-list');
          })
          .catch(() => {
            this.$message.error('保存失败');
          });
      },
      /** 取消 */
      handleCancel() {
        this.showDrawer = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .city-section {
    margin-bottom: 20px;
    padding: 16px;
    background: #f8f9fa;
    border-radius: 6px;
  }
  .city-section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
  }
  .city-section-title {
    font-size: 14px;
    font-weight: 600;
    color: #303133;
  }
  .city-row {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
  }
  .city-empty {
    color: #909399;
    font-size: 13px;
    text-align: center;
    padding: 8px 0;
  }
  .error-tip {
    color: #f56c6c;
    font-size: 12px;
    margin-left: 8px;
    white-space: nowrap;
  }
</style>
